import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { openSafePaymentLink } from "../../helpers/donationPaymentLink";

interface PaymentLinkWarningDialogProps {
  open: boolean;
  link: string | null | undefined;
  status: string | null | undefined;
  onClose: () => void;
}

const PaymentLinkWarningDialog = ({
  open,
  link,
  status,
  onClose,
}: PaymentLinkWarningDialogProps) => {
  const isRejected = (status || "").toLowerCase().trim() === "rejected";

  const handleOpen = () => {
    if (openSafePaymentLink(link)) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: "16px" } }}
    >
      <DialogTitle>
        {isRejected ? "Rejected payment link" : "Unverified payment link"}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {isRejected
            ? "This payment link was rejected and is not approved for donors. Open it only if you trust this organization."
            : "This payment link is still pending CMZ review. Open it only if you trust this organization."}
        </Typography>
        {link && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mb: 2, wordBreak: "break-all" }}
          >
            {link}
          </Typography>
        )}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button onClick={onClose} sx={{ textTransform: "none" }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleOpen}
            sx={{
              textTransform: "none",
              bgcolor: "#1B8368",
              "&:hover": { bgcolor: "#166b55" },
            }}
          >
            Open link
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentLinkWarningDialog;
